import { __decorate, __metadata } from "tslib";
import { Component, Inject, Prop, Ref } from "vue-property-decorator";
import LvTabGroup, { SYM_LV_TAB_GROUP } from "../tab-group/LvTabGroup.vue";
import { UIComponent } from "../UIComponent";
export const COMPONENT_NAME = "LvTab";
let LvTab = class LvTab extends UIComponent {
    constructor() {
        super(...arguments);
        this.isActive = false;
    }
    mounted() {
        this.registerToGroup();
    }
    beforeDestroy() {
        this.unregisterFromGroup();
    }
    /**
     * @private
     */
    registerToGroup() {
        this.group.registerChild(this);
    }
    /**
     * @private
     */
    unregisterFromGroup() {
        this.group.unregisterChild(this);
    }
    setActive() {
        this.group.setCurrentTab(this);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], LvTab.prototype, "name", void 0);
__decorate([
    Inject(SYM_LV_TAB_GROUP),
    __metadata("design:type", LvTabGroup)
], LvTab.prototype, "group", void 0);
__decorate([
    Ref(),
    __metadata("design:type", HTMLDivElement)
], LvTab.prototype, "tabHeader", void 0);
LvTab = __decorate([
    Component({
        name: COMPONENT_NAME,
    })
], LvTab);
export default LvTab;
//# sourceMappingURL=script.js.map